import React from 'react';
import PropTypes from 'prop-types';
import { withFocus } from '@accedo/vdkweb-navigation';
import { isEmpty } from 'lodash';
import { FocusDiv } from '#/widgets/ui';
import styles from './TVPlayerControls.scss';
import { PLAYER, PLAYER_TOP_OVERLAY } from '#/utils/navigationHelper';
import FF from '#/static/images/icons/tvPlayerControl/FF.png';
import RW from '#/static/images/icons/tvPlayerControl/RW.png';
import NEXT from '#/static/images/icons/tvPlayerControl/Next.png';
import PREV from '#/static/images/icons/tvPlayerControl/Previous.png';
import PLAY from '#/static/images/icons/tvPlayerControl/Play.png';
import PAUSE from '#/static/images/icons/tvPlayerControl/Pause.png';
import { ROLES } from '#/utils/accessibility';

const FocusImg = ({
  nav,
  onClick,
  ariaLabel,
  isFocused,
  className,
  alt,
  ...props
}) => (
  <FocusDiv
    nav={nav}
    onClick={onClick}
    ariaLabel={ariaLabel}
    className={className}
    classNameFocused={styles.isFocused}
  >
    <img {...props} alt={alt} aira-hidden="true" />
  </FocusDiv>
);

FocusImg.propTypes = {
  nav: PropTypes.object,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  alt: PropTypes.string,
  isFocused: PropTypes.bool,
  className: PropTypes.string,
};

const TVPlayerControls = ({
  isVOD = true,
  onRWClick,
  onFFClick,
  onPrevTrack,
  onNextTract,
  onPlayPauseClick,
  isVideoPlaying,
  seekSpeed,
  controlsDisabled,
  moreContentItems,
}) => {
  return (
    <FocusDiv
      nav={{
        id: PLAYER.TRANSPORT_CONTROLS,
        nextdown: isEmpty(moreContentItems) ? undefined : PLAYER.CONTROL,
        nextup: PLAYER_TOP_OVERLAY.CONTAINER,
        parent: PLAYER.CONTAINER,
        forwardFocus: PLAYER.PLAY_PAUSE,
        useLastFocus: true,
      }}
      className={`${styles.container} ${isEmpty(moreContentItems) &&
        styles.noMoreContentItems}`}
    >
      {isVOD && !controlsDisabled && (
        <>
          <FocusImg
            className={styles.icon}
            nav={{
              id: PLAYER.PREV_TRACK,
              nextright: PLAYER.RW,
              parent: PLAYER.TRANSPORT_CONTROLS,
            }}
            src={PREV}
            onClick={onPrevTrack}
            alt="PREV_TRACK"
            ariaLabel="Previous track"
          />
          <div className={styles.seekSpeed}>
            <span>{seekSpeed < -1 ? `x${Math.abs(seekSpeed)}` : ''}</span>
          </div>
          <FocusImg
            className={styles.icon}
            nav={{
              id: PLAYER.RW,
              nextright: PLAYER.PLAY_PAUSE,
              nextleft: PLAYER.PREV_TRACK,
              parent: PLAYER.TRANSPORT_CONTROLS,
            }}
            src={RW}
            onClick={onRWClick}
            alt="RW"
            ariaLabel={`Rewind ${ROLES.BUTTON}`}
          />
        </>
      )}
      <FocusImg
        className={styles.icon}
        nav={{
          id: PLAYER.PLAY_PAUSE,
          nextleft: isVOD && !controlsDisabled ? PLAYER.RW : null,
          nextright: isVOD && !controlsDisabled ? PLAYER.FF : null,
          parent: PLAYER.TRANSPORT_CONTROLS,
        }}
        src={!isVideoPlaying ? PLAY : PAUSE}
        ariaLabel={
          !isVideoPlaying ? `play ${ROLES.BUTTON}` : `pause ${ROLES.BUTTON}`
        }
        onClick={onPlayPauseClick}
        alt="PlayPause"
      />
      {isVOD && !controlsDisabled && (
        <>
          <FocusImg
            className={styles.icon}
            nav={{
              id: PLAYER.FF,
              nextleft: PLAYER.PLAY_PAUSE,
              nextright: PLAYER.NEXT_TRACK,
              parent: PLAYER.TRANSPORT_CONTROLS,
            }}
            src={FF}
            onClick={onFFClick}
            ariaLabel={`Fast forward ${ROLES.BUTTON}`}
            alt="FF"
          />
          <div className={styles.seekSpeed}>
            <span>{seekSpeed > 1 ? `x${seekSpeed}` : ''}</span>
          </div>
          <FocusImg
            className={styles.icon}
            nav={{
              id: PLAYER.NEXT_TRACK,
              nextleft: PLAYER.FF,
              parent: PLAYER.TRANSPORT_CONTROLS,
            }}
            src={NEXT}
            onClick={onNextTract}
            ariaLabel="Next track"
            alt="NEXT_TRACK"
          />
        </>
      )}
    </FocusDiv>
  );
};

TVPlayerControls.propTypes = {
  isVOD: PropTypes.bool,
  onRWClick: PropTypes.func,
  onFFClick: PropTypes.func,
  onPrevTrack: PropTypes.func,
  onNextTract: PropTypes.func,
  onPlayPauseClick: PropTypes.func,
  isVideoPlaying: PropTypes.bool,
  controlsDisabled: PropTypes.bool,
  seekSpeed: PropTypes.number,
  moreContentItems: PropTypes.array,
};

export default withFocus(TVPlayerControls);
